/**
 * @generated SignedSource<<7542446408a11d8dcd6f34ea8741757a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type goals_issueFieldGoalsInlineEditFull_GoalsInlineEditView_fragmentRef$data = {
  readonly fieldConfig: {
    readonly isEditable: boolean | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"goals_issueFieldGoalsInlineEditFull_GoalsInlineEditViewWithIsEditable_fragmentRef">;
  readonly " $fragmentType": "goals_issueFieldGoalsInlineEditFull_GoalsInlineEditView_fragmentRef";
};
export type goals_issueFieldGoalsInlineEditFull_GoalsInlineEditView_fragmentRef$key = {
  readonly " $data"?: goals_issueFieldGoalsInlineEditFull_GoalsInlineEditView_fragmentRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"goals_issueFieldGoalsInlineEditFull_GoalsInlineEditView_fragmentRef">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "goals_issueFieldGoalsInlineEditFull_GoalsInlineEditView_fragmentRef",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "goals_issueFieldGoalsInlineEditFull_GoalsInlineEditViewWithIsEditable_fragmentRef"
    },
    {
      "concreteType": "JiraFieldConfig",
      "kind": "LinkedField",
      "name": "fieldConfig",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isEditable"
        }
      ]
    }
  ],
  "type": "JiraGoalsField"
};

(node as any).hash = "d698a934047d8a1aef53370ee1f7570c";

export default node;
